import { makeStyles } from 'tss-react/mui';

const useStylesUploadFilePreviewItem: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  uploadFilePreviewItemDeleteButton: {
    cursor: 'pointer',
    marginRight: '2px !important',
    marginTop: '-3px !important',
    color: `${theme.palette.secondary.main} !important`,
    width: 24,
    height: 24,
    '& > span:first-of-type': {
      marginTop: -5,
    },
  },
  uploadFilePreviewItemDeleteButtonInline: {
    marginLeft: '5px !important',
  },
}));

export default useStylesUploadFilePreviewItem;
